export default __webpack_public_path__ + "static/media/segre08.666b8e0f.jpg";